// TODO: This should convert the units to the users preference!
export const formatArea = area => `${(area / 1000000).toFixed(3)} km²`;

// Adapted from https://gist.github.com/zentala/1e6f72438796d74531803cc3833c039c
export function formatBytes(bytes, decimals = 2, k = 1024) {
  if (bytes === 0) {
    return '0 B';
  }
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return (
    parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i]
  );
}
